var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBannerImage1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 401.186 343.926",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_3",
    x: 12.439,
    y: 144.667,
    width: 159.544,
    height: 134.167,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.813,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.344,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_4",
    x: 159.972,
    y: 18.136,
    width: 221.051,
    height: 236.334,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.813,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.344,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_5",
    x: 31.828,
    y: 59.035,
    width: 330.558,
    height: 237.167,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.813,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.344,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.149
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33",
    transform: "translate(-61.061 -184.578)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 61.06, 184.58)",
    filter: "url(#Rectangle_3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3-2",
    "data-name": "Rectangle 3",
    width: 133.756,
    height: 104.622,
    rx: 9.336,
    transform: "translate(19.47 165.14) rotate(-6.98)",
    fill: "#fac14d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 61.06, 184.58)",
    filter: "url(#Rectangle_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4-2",
    "data-name": "Rectangle 4",
    width: 142.829,
    height: 177.059,
    rx: 9.336,
    transform: "translate(167.01 86.3) rotate(-26.6)",
    fill: "#5439f8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M173.25,291.874C102.243,210.689,208.567,146.183,270.821,214s130.366,37.324,152.118,63.4,30.97,127.327-88.829,111.458S334.252,455.9,288.539,504s-186.4,18.151-145.642-59.045-75.4-48.606-67.984-124.952S173.25,291.874,173.25,291.874Z",
    transform: "translate(12.84 0.932)",
    fill: "none",
    stroke: "#fac14d",
    strokeMiterlimit: 10,
    strokeWidth: 0.488
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(99.922 247.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -38.86, -63.25)",
    filter: "url(#Rectangle_5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5-2",
    "data-name": "Rectangle 5",
    width: 297.109,
    height: 191.34,
    transform: "matrix(0.99, 0.11, -0.11, 0.99, 60.08, 63.25)",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 297.109,
    height: 25.064,
    transform: "matrix(0.994, 0.111, -0.111, 0.994, 21.214, 0)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M369.891,262.708,98.656,232.451a4.2,4.2,0,0,1-3.712-4.644h0a4.2,4.2,0,0,1,4.644-3.712l271.236,30.258A4.2,4.2,0,0,1,374.535,259h0A4.2,4.2,0,0,1,369.891,262.708Z",
    transform: "translate(-67.743 -210.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M101.217,223.1a2.89,2.89,0,1,1-2.551-3.191A2.891,2.891,0,0,1,101.217,223.1Z",
    transform: "translate(-67.232 -214.272)",
    fill: "#3fc080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M106.723,223.713a2.889,2.889,0,1,1-2.551-3.193A2.89,2.89,0,0,1,106.723,223.713Z",
    transform: "translate(-61.997 -213.689)",
    fill: "#5439f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M112.232,224.326a2.89,2.89,0,1,1-2.551-3.191A2.891,2.891,0,0,1,112.232,224.326Z",
    transform: "translate(-56.762 -213.104)",
    fill: "#fac14d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M312.235,310.687,117.312,288.943A13.718,13.718,0,0,1,105.2,273.789h0a13.716,13.716,0,0,1,15.153-12.111l194.921,21.744a13.719,13.719,0,0,1,12.112,15.153h0A13.716,13.716,0,0,1,312.235,310.687Z",
    transform: "translate(-58.049 -174.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("text", {
    id: "keyword",
    transform: "translate(59.446 104.174) rotate(6.366)",
    fill: "#4d4d4d",
    fontSize: 18,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "keyword")), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M223.957,285.057l-8.618-10.137-.515,4.615-7.938-.886-.993,8.9,7.938.886-.515,4.614Z",
    transform: "translate(37.737 -161.966)",
    fill: "#5237f4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(79.916 297.377)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 13.775,
    height: 13.775,
    transform: "translate(53.158 80.326) rotate(38.02)",
    fill: "#3d26c7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M169.137,252.826a49.08,49.08,0,1,0,8.434,68.895A49.081,49.081,0,0,0,169.137,252.826Zm-54.422,69.607a39.276,39.276,0,1,1,55.132-6.751A39.275,39.275,0,0,1,114.715,322.433Z",
    transform: "translate(-52.576 -242.41)",
    fill: "#5439f8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M128.178,296.771l-10.932-8.549c-1.943-1.519-3.458-.166-4.978,1.779L71.676,339.255a4.466,4.466,0,0,0,.767,6.269l10.934,8.549a4.464,4.464,0,0,0,6.269-.769l38.007-51.274C129.172,300.087,130.12,298.291,128.178,296.771Z",
    transform: "translate(-70.728 -199.487)",
    fill: "#3fc080"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M210.962,318.953a20.055,20.055,0,0,0-22.1-14.878c-.092.01-.185.029-.277.041s-.185.016-.277.025a20.059,20.059,0,0,0-17.855,19.772,4.412,4.412,0,0,0-.053.923l.019.158.31,2.526.012.107c.006.045.018.09.023.135.041.246.105.618.168.944.02.088.035.177.057.265l.014.07c.039.154.092.31.137.464a16.4,16.4,0,0,0,.923,2.461c.076.166.152.332.234.5.057.113.115.226.174.339,2.3,4.506,6.331,8.931,9.618,13.216,4.371,5.682,8.867,11.25,13.333,16.817.137.179.271.361.408.538l.01-.018.012.016c.09-.207.177-.414.265-.62,2.994-6.481,6.013-12.969,8.884-19.538,2.155-4.952,5-10.217,6.144-15.144.031-.127.06-.252.088-.378.039-.178.072-.355.105-.532a16.277,16.277,0,0,0,.3-2.623c.006-.158.018-.32.019-.476l0-.07c0-.092-.008-.183-.01-.275-.018-.33-.045-.706-.064-.954-.006-.045,0-.092-.01-.137l-.014-.105-.31-2.528-.018-.158A4.551,4.551,0,0,0,210.962,318.953Zm-19.013,12.59a7.773,7.773,0,0,1-6.322-2.229,8.893,8.893,0,0,1-1.332-1.847,7,7,0,0,1-.423-1.822l-.2-1.635a6.8,6.8,0,0,1,.2-2.752,7.414,7.414,0,0,1,3.072-3.8c.17-.1.343-.189.519-.275.154-.078.314-.146.476-.215a8.383,8.383,0,0,1,.9-.32,7.389,7.389,0,0,1,.991-.224c.086-.014.172-.029.258-.041s.174-.016.261-.023a7.719,7.719,0,0,1,1.016-.021,8.746,8.746,0,0,1,.952.094c.172.027.345.055.513.094.191.041.382.088.57.142a7.414,7.414,0,0,1,3.9,2.945,6.783,6.783,0,0,1,.862,2.621l.2,1.633a6.876,6.876,0,0,1,.029,1.871,8.8,8.8,0,0,1-.847,2.112A7.772,7.772,0,0,1,191.948,331.543Z",
    transform: "translate(103.921 113.435)",
    fill: "#3fc080"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(346.913 242.46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M248.549,285.1l2.6-16.8a31.639,31.639,0,0,1-26.458-26.94l-16.846,2.294a48.656,48.656,0,0,0,40.7,41.446Z",
    transform: "translate(-207.399 -188.494)",
    fill: "#3fc080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M224.905,253.58a31.582,31.582,0,0,1,2.777-17.806l-15.35-7.3a48.561,48.561,0,0,0-4.274,27.4Z",
    transform: "translate(-207.616 -200.737)",
    fill: "#fac14d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M225.388,249.273a31.58,31.58,0,1,1,40.771,42.677l6.593,15.668a48.578,48.578,0,1,0-62.714-65.643Z",
    transform: "translate(-205.313 -214.254)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M254.973,269.758l-6.591-15.666a31.428,31.428,0,0,1-17.059,2.1l-2.6,16.8A48.321,48.321,0,0,0,254.973,269.758Z",
    transform: "translate(-187.554 -176.389)",
    fill: "#5439f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(163.791 425.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M120.736,339.89a18.082,18.082,0,0,0,2.77,3.08l-1.03,2.947a2.008,2.008,0,0,0,1.014,2.465l4.25,2.064a2,2,0,0,0,2.565-.731l1.668-2.614a17.635,17.635,0,0,0,4.3.283l1.371,2.838a2,2,0,0,0,2.46,1.024l4.467-1.549a2,2,0,0,0,1.293-2.327l-.657-2.965a17.882,17.882,0,0,0,3.454-3.017l2.832.987a2.011,2.011,0,0,0,2.465-1.012l2.062-4.254a2,2,0,0,0-.73-2.563l-2.489-1.593a17.425,17.425,0,0,0,.281-4.523l2.559-1.231a2.008,2.008,0,0,0,1.026-2.461l-1.549-4.465a2.007,2.007,0,0,0-2.329-1.3l-2.733.6a17.432,17.432,0,0,0-2.941-3.355l.907-2.6a2.009,2.009,0,0,0-1.012-2.465l-4.244-2.058a2,2,0,0,0-2.563.73l-1.439,2.259a17.594,17.594,0,0,0-4.7-.3l-1.188-2.463a2,2,0,0,0-2.46-1.022l-4.469,1.549a2,2,0,0,0-1.3,2.325l.591,2.672a17.541,17.541,0,0,0-3.595,3.242l-2.625-.919a2.011,2.011,0,0,0-2.465,1.016l-2.06,4.252a2,2,0,0,0,.731,2.563l2.475,1.58a17.092,17.092,0,0,0-.189,4.482l-2.645,1.27a2,2,0,0,0-1.024,2.46l1.549,4.467a2,2,0,0,0,2.329,1.3Zm11.994-17.7a7.816,7.816,0,1,1-4.824,9.946,7.829,7.829,0,0,1,4.824-9.946Zm0,0",
    transform: "translate(-113.73 -308.195)",
    fill: "#3fc080"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M160.886,314.916l-3.049-1.174a1.973,1.973,0,0,0-2.461.928l-.878,1.67a14.3,14.3,0,0,0-3.86.084l-.993-1.668a1.987,1.987,0,0,0-2.506-.807l-2.984,1.33a1.983,1.983,0,0,0-1.088,2.4l.573,1.847a14.347,14.347,0,0,0-2.711,2.894l-1.911-.493a1.979,1.979,0,0,0-2.341,1.205l-1.166,3.062a1.967,1.967,0,0,0,.928,2.46l1.865.979a14.923,14.923,0,0,0,.148,3.671l-1.808,1.071a2,2,0,0,0-.806,2.51l1.328,2.984a1.985,1.985,0,0,0,2.4,1.086l2.124-.661a14.563,14.563,0,0,0,2.475,2.325l-.558,2.181a1.98,1.98,0,0,0,1.2,2.342l3.049,1.17a1.972,1.972,0,0,0,2.461-.928l1.04-1.978a14.385,14.385,0,0,0,3.523-.066l1.159,1.962a1.991,1.991,0,0,0,2.51.806l2.984-1.328a1.981,1.981,0,0,0,1.086-2.4l-.648-2.089a14.653,14.653,0,0,0,2.608-2.7l2.087.533a1.985,1.985,0,0,0,2.342-1.205l1.17-3.047a1.973,1.973,0,0,0-.928-2.462l-1.874-.977a14.144,14.144,0,0,0-.08-3.71l1.74-1.03a1.993,1.993,0,0,0,.806-2.51l-1.328-2.982a1.978,1.978,0,0,0-2.4-1.088l-1.9.591a14.428,14.428,0,0,0-2.633-2.54l.49-1.9a1.965,1.965,0,0,0-1.192-2.35Zm-5.426,21.795a6.4,6.4,0,1,1,3.251-8.444,6.394,6.394,0,0,1-3.251,8.444Zm0,0",
    transform: "translate(-93.156 -303.049)",
    fill: "#fac14d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M128.223,344.047a1.979,1.979,0,0,0-1.038,2.422l.634,1.9a1.974,1.974,0,0,0,2.282,1.313l1.453-.3a11.424,11.424,0,0,0,1.828,2.073l-.515,1.418a1.978,1.978,0,0,0,.975,2.446l1.794.9a1.975,1.975,0,0,0,2.543-.69l.817-1.246a11.54,11.54,0,0,0,2.857.222l.648,1.385a1.982,1.982,0,0,0,2.424,1.038l1.9-.634A1.976,1.976,0,0,0,148.14,354l-.3-1.422a11.79,11.79,0,0,0,2.329-1.982l1.342.484a1.975,1.975,0,0,0,2.444-.975l.9-1.794a1.98,1.98,0,0,0-.69-2.543L153,345.008a11.5,11.5,0,0,0,.228-3.014l1.2-.556a1.978,1.978,0,0,0,1.038-2.423l-.634-1.9a1.971,1.971,0,0,0-2.282-1.311l-1.266.263a11.871,11.871,0,0,0-1.933-2.264l.433-1.19a1.975,1.975,0,0,0-.971-2.444l-1.8-.9a1.973,1.973,0,0,0-2.543.69l-.665,1.008a11.646,11.646,0,0,0-3.132-.238l-.527-1.133a1.978,1.978,0,0,0-2.423-1.036l-1.9.634a1.971,1.971,0,0,0-1.313,2.282l.254,1.219a11.98,11.98,0,0,0-2.419,2.13l-1.2-.437a1.971,1.971,0,0,0-2.444.973l-.9,1.8a1.977,1.977,0,0,0,.689,2.545l1.159.753a11.462,11.462,0,0,0-.16,2.99ZM139.7,337.67a5.211,5.211,0,1,1-3.3,6.591,5.209,5.209,0,0,1,3.3-6.591Zm0,0",
    transform: "translate(-101.039 -288.932)",
    fill: "#5439f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(371.224 409.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M258.665,309.986a12.051,12.051,0,0,0-11.174.973,2.185,2.185,0,0,1-3.5-1.467,12.051,12.051,0,0,0-23.847,2.247c-.936,10.971,8.227,28.175,12.249,30.346,4.367,1.344,23.059-4.192,30.221-12.555a12.041,12.041,0,0,0-3.952-19.544Zm0,0",
    transform: "translate(-220.08 -299.906)",
    fill: "#fac14d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(350.042 408.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(0 28.395)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M233.587,395.848a85.124,85.124,0,0,1-24.367-.517l2.21-13.267a71.72,71.72,0,0,0,83.43-67.929l13.441.5a85.128,85.128,0,0,1-74.713,81.214Z",
    transform: "translate(-209.22 -314.135)",
    fill: "#5439f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17",
    transform: "translate(72.251)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M286.217,331.794l-24.1-32.217-15.858,36.976Z",
    transform: "translate(-246.263 -299.577)",
    fill: "#5439f8"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(61.061 184.578)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    transform: "translate(13.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M142.5,185.214a85.267,85.267,0,0,1,24.367.517L164.66,199a71.719,71.719,0,0,0-83.428,67.929l-13.441-.5A85.123,85.123,0,0,1,142.5,185.214Z",
    transform: "translate(-67.791 -184.578)",
    fill: "#3fc080"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    "data-name": "Group 22",
    transform: "translate(0 73.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    "data-name": "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M61.061,227.157l24.1,32.217L101.016,222.4Z",
    transform: "translate(-61.061 -222.399)",
    fill: "#3fc080"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerImage1);
export default __webpack_public_path__ + "static/media/banner_image_1.aa2f0034b128ce0730f62577f7ffc36a.svg";
export { ForwardRef as ReactComponent };